import api from './api.service';
import { RoomDetail, RoomCreateRequest, RoomUpdateRequest } from '../types/room';

class RoomsService {
  async listForColoc(colocId: string): Promise<RoomDetail[]> {
    const response = await api.get(`/rooms/coloc/${colocId}`);
    return response.data;
  }

  async create(colocId: string, data: RoomCreateRequest): Promise<RoomDetail> {
    const response = await api.post(`/rooms/coloc/${colocId}`, data);
    return response.data;
  }

  async update(roomId: string, data: RoomUpdateRequest): Promise<RoomDetail> {
    const response = await api.put(`/rooms/${roomId}`, data);
    return response.data;
  }

  /** Fermer (`true`) ou rouvrir (`false`) : rien n'est effacé. */
  async setClosed(roomId: string, closed: boolean): Promise<RoomDetail> {
    const response = await api.put(`/rooms/${roomId}/closed`, { closed });
    return response.data;
  }

  async delete(roomId: string): Promise<void> {
    await api.delete(`/rooms/${roomId}`);
  }
}

export const roomsService = new RoomsService();
